import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Layout } from 'antd';
import { compose, lifecycle } from 'recompose';
import styled from 'styled-components';

import Routes from './Routes';
import { actions as authActions } from 'modules/auth';
import { actions as appActions } from 'modules/app';
import SideMenu from 'components/Layout/SideMenu';
import Header from 'components/Layout/Header';
import { getHeader } from 'utils/helpers';

const FooterText = styled.p`
  text-align: center;
  margin-bottom: 0;
`;

const LayoutHeader = styled(Layout.Header)`
  background-color: ${props => props.theme.white} !important;
  color: ${props => props.theme.black};
  padding: 0 25px !important;
  z-index: 3;
  box-shadow: 0 1px 4px 0 rgba(0, 21, 41, 0.12);
`;

const Content = styled(Layout.Content)`
  min-height: calc(100vh - 111px);
  background-color: ${props => props.theme.lightGray2};
  padding: ${props => (props.noPadding ? '0' : '15px 25px')};
`;

const Footer = styled(Layout.Footer)`
  padding: 13px 25px !important;
`;

const ContentLayout = styled(Layout)`
  ${props => !props.noPad && `
    @media (min-width: 769px) {
      padding-left: 200px;
    }
  `}
`;

const enhance = compose(
  withRouter,
  connect(
    state => ({
      isShowLayout: state.router.location.pathname !== '/login',
      headerObj: getHeader(state.router.location.pathname)
    }),
    {...authActions, ...appActions}
  ),
  lifecycle({
    async componentDidMount() {
      const [data] = await Promise.all([
        this.props.getMe(),
        this.props.getExchangeRates()
      ]);
      if (data && data.user && !data.user.is_partner) {
        this.props.logout();
      }
    }
  }),
);

const App = props => {
  const { headerObj } = props;
  return (
    <Layout>
      {props.isShowLayout && (
        <SideMenu selectedKeys={headerObj.activeKeys} />
      )}
      <ContentLayout noPad={!props.isShowLayout}>
        {props.isShowLayout && (
          <LayoutHeader>
            <Header title={headerObj.title} />
          </LayoutHeader>
        )}
        <Content noPadding={!props.isShowLayout}>
          <Routes />
        </Content>
        {props.isShowLayout && (
          <Footer>
            <FooterText>Copyright © 2018 TakeMeTour Pte. Ltd. All rights reserved.</FooterText>
          </Footer>
        )}
      </ContentLayout>
    </Layout>
  );
};

export default enhance(App);



// WEBPACK FOOTER //
// ./src/App.js